import React from 'react';
import { Box, Image } from 'grommet';

const LacrosseIcon = (props) => <Box height="1em" width="1em" {...props}><Image src="lacrosse.svg" /></Box>;

export default LacrosseIcon;
